import { Sparkles } from "lucide-react";

/**
 * Live gift card preview — mirrors the /carte-cadeau/print/:code design
 * so the buyer sees exactly what will be printed / emailed.
 */
export default function GiftCardPreview({ productName, recipientName, buyerName, dedication, code = "CADEAU-XXXXXXXX", scale = "sm" }) {
  const size = scale === "sm" ? "p-8 md:p-10" : "p-12 md:p-16";
  const codeSize = scale === "sm" ? "text-xl md:text-2xl tracking-[0.3em] py-3 px-4" : "text-3xl md:text-4xl tracking-[0.4em] py-4 px-6";
  const titleSize = scale === "sm" ? "text-2xl md:text-3xl" : "text-4xl md:text-5xl";

  return (
    <div data-testid="gift-card-preview" className={`relative bg-[#F5F0E6] ${size} border border-[#C5A880] paper-grain shadow-[0_18px_60px_rgb(44,38,33,0.08)]`}>
      {/* Decorative corners */}
      <div className="absolute top-4 left-4 w-8 h-8 border-t border-l border-[#A3876A]"></div>
      <div className="absolute top-4 right-4 w-8 h-8 border-t border-r border-[#A3876A]"></div>
      <div className="absolute bottom-4 left-4 w-8 h-8 border-b border-l border-[#A3876A]"></div>
      <div className="absolute bottom-4 right-4 w-8 h-8 border-b border-r border-[#A3876A]"></div>

      <div className="text-center mb-6">
        <p className="font-hand text-2xl text-[#A3876A] mb-2">Un cadeau pour toi</p>
        <Sparkles size={16} className="mx-auto text-[#A3876A]"/>
      </div>

      <div className="text-center mb-6">
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#7C7064] mb-3">Carte cadeau</p>
        <h3 className={`font-serif ${titleSize} text-[#2C2621] leading-tight mb-3 min-h-[3rem]`}>
          {productName || <span className="text-[#7C7064] italic">Choisissez une formule</span>}
        </h3>
        {recipientName ? (
          <p className="font-hand text-2xl text-[#A3876A] mt-4">Pour {recipientName}</p>
        ) : (
          <p className="font-hand text-2xl text-[#DCCBBA] mt-4">Pour ✧</p>
        )}
      </div>

      {dedication && (
        <div className="max-w-md mx-auto mb-6 py-4 border-y border-[#DCCBBA] text-center">
          <p className="editorial-quote text-[#4A4036] italic text-base leading-snug">« {dedication} »</p>
          {buyerName && <p className="font-hand text-lg text-[#A3876A] text-right mt-2">— {buyerName}</p>}
        </div>
      )}

      <div className="text-center">
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#7C7064] mb-2">Code à saisir</p>
        <p className={`font-serif ${codeSize} text-[#2C2621] bg-[#FDFBF7] inline-block border border-[#DCCBBA]`}>
          {code}
        </p>
      </div>
    </div>
  );
}
